<section data-test="k2VbT7wq">
  <div data-test="pQ4xN8Ls" class="modules-container">
    <h1 data-test="mJ6cD1Ry" class="text-center">No access to this workspace</h1>
    <p data-test="uW9fH3Kz" class="text-center">
      You are signed in as
      <strong>{{ username }}</strong>
      , who does not have access to this workspace.
    </p>
    <p data-test="rB5gM2Xn" class="text-center">
      Signing in with another account will sign you out of your current session
      everywhere. To keep your session, simply close this tab.
    </p>
    <p data-test="vC8dJ4Tp" class="text-center">
      <button data-test="yF3hR6Qm" type="button" (click)="switchAccount()">
        Log in with another account
      </button>
    </p>
  </div>
</section>
